export default `
    <span class="#= data.containerClasses || ""# #=data.bsc||""#">
        <span class="#= data.bindClass # pad-r-5 #= data.classes #" id="#= data.id #"
            # if (data.labelWidth) { #
                 style="width: #= data.labelWidth #px;"
            # } #
            # if (data.bindValue) { # data-bind="#= data.bindValue #" # } #
            # if (data.labelFor) { # data-label-for="#= data.labelFor #" # } #
        >
        # if(data.hardCodedValue) { # #=data.hardCodedValue # #} #
        </span>
    </span>
`;
